/*
 * @Author: v_smwang
 * @Date: 2020-07-29 16:20:30
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-08-18 17:34:18
 * @FilePath: \src\libs\MapAccount\index.js
 * @Description: 描述
 * @Module: 模块路径
 */
import service from '@tencent/tks-utils/promise/service';
import TksAccount from './TksAccout';
/**
 * loginv2Json——测试数据，上线记得屏蔽
 * 测试使用，测试环境登录失败或者后台关闭了登录功能时
 */
// let loginv2Json = require('@/config/login_v2')
// console.log('loginv2Json', loginv2Json)

const path = window.location.pathname.replace(/index\.html/, '');
const ssoProxyPath = `${window.location.origin}${path}mapssoproxy.html`;
const platformId = 'persona'; // 预发环境和正式环境appid一致

let ACCOUNT_ENV = 'test'; // 账号平台预发环境
if (window.location.href.search('iframe=1') !== -1 || window.location.origin === 'https://profile.map.qq.com' || window.location.origin === 'http://profile.map.oa.com') { // 嵌套和人员画像正式，走账号平台正式appid
  ACCOUNT_ENV = 'prod'; // 账号平台正式环境
}

let SSO_URL_ID = 'common'; // 登录接口的类别
const SSO_URL = {
  // 登录接口
  common: '/service/auth', // 人员画像直接访问的时候都是走该接口
  iframe: '/profile/service/auth', // 被其他系统用iframe嵌套的时候
};
if (window.location.href.search('iframe=1') !== -1) { // 嵌套走该接口
  SSO_URL_ID = 'iframe';
}
console.log('window.location.href---->', window.location.href);
console.log('SSO_URL---->', SSO_URL[SSO_URL_ID]);
console.log('ACCOUNT_ENV---->', ACCOUNT_ENV);
// 如果接入 auth.map.qq.com 则 ACCOUNT_ENV 为 prod
// 如果接入 sso.map.qq.com 则 ACCOUNT_ENV 为 test
// 如果接入 inner_sso.map.qq.com 则 ACCOUNT_ENV 为 dev
// const ACCOUNT_ENV = 'prod'

export default new TksAccount({
  env: ACCOUNT_ENV,
  ssoProxyPath,
  platformId,
  async authPromise() {
    const url = SSO_URL[SSO_URL_ID];
    const { data: response } = await service({ url });
    // const response = loginv2Json // 测试使用

    const { data } = response;
    // console.log('response.data', response.data)

    // 101未登录
    if (response.status !== 200) {
      // 未登录
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        code: response.status,
        message: response.msg || '服务器错误',
      });
    }

    return {
      userInfo: data.user_info,
      roles: data.access_codes,
    };
  },
});
